"use strict";

const SoaCollection = require('bunsen/collections/SoaCollection');
const AuthorizedRoles = require('bunsen/collections/identity/AuthorizedRoles');
let AvailableAction = require('bunsen/models/AvailableAction');
const _types = {
    WF : "WORKFLOW_TRANSITION"
};

/**
 *
 * This collection has method related to the available actions property of a given entity. Handy for reading and
 * manipulating available actions. Require this file and add as a relation to your model.
 * Available actions tell your model what actions are available to be taken on it.
 * They also contain authorizedRoles models in some cases to state what users are allowed to take those actions.
 * Use these methods to check for certain actions or permission to take certain actions.
 * @type {{}}
 */
let AvailableActions = SoaCollection.extend({

    model : AvailableAction,

    /**
     * Get all actions that are of type workflow transition. Basically gets all the possible WF states the model
     * is able to transition to. Returns another instance of AvailableActions collection.
     * @returns {*}
     */
    getAvailableWFTransitions () {
        return new AvailableActions(this.where({type : _types.WF}));
    },

    /**
     * Ask for an action by name. If available this method returns true.
     * @param actionName
     */
    actionIsAvailable (actionName) {
        return !!this.where({code : actionName}).length;
    },

    /**
     * Query this method to see if your user can take a given action. Accepts user/seller and checks to see if the
     * action is available AND you are permitted to do it.
     * @param actionName
     * @param userOrSeller
     * @returns {*}
     */
    isUserAuthorizedFor (actionName, userOrSeller) {
        if (!this.actionIsAvailable(actionName)) {
            return false;
        }

        let action = this.findWhere({code : actionName});
        let roles = action.getRoles(); // returns authorized roles collection

        // if no roles were included then anyone can perform this action unless blocked by other permission.
        if (!roles || !roles.length) {
            return true;
        }

        return roles.isUserPermitted(userOrSeller);
    }

});



module.exports = AvailableActions;


// WEBPACK FOOTER //
// ./~/bunsen/collections/AvailableActions.es.js